<template>
  <div class="info-box static">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="overflow-y-auto px-2.5 flex-1"
    >
      <ul class="grid gap-x-5" style="grid-template-columns: 3.13fr auto 5fr">
        <el-form-item
          label="楼层"
          prop="floor"
          :rules="[{ required: true, message: '请输入楼层', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.floor"></el-input>
        </el-form-item>

        <el-form-item
          label="房号"
          prop="number"
          :rules="[{ required: true, message: '请输入房号', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.number"></el-input>
        </el-form-item>
        <el-form-item label="房间名称">
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
      </ul>
      <el-form-item label="备注">
        <el-input v-model="state.model.remark" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_hotelArrange_room_add } from "@/http/meeting";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    room_type: Object,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      console.log(props);
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.meeting_id = props.room_type.meeting_id;
          state.model.meeting_hotel_arrange_id =
            props.room_type.meeting_hotel_arrange_id;
          state.model.meeting_hotel_arrange_room_type_id = props.room_type.id;
          state.model.hotel_id = props.room_type.hotel_id;
          state.model.hotel_room_type_id = props.room_type.hotel_room_type_id;

          meeting_hotelArrange_room_add(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
